var Wind = (function($) {
  function initWind() {
    async function updateWindArrow() {
      const API_KEY = "36bc8cda6145cf2d549eb6ff478e1dd6";
      const url = `https://api.openweathermap.org/data/2.5/weather?q=Barcelona,ES&units=metric&appid=${API_KEY}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        const windDeg = data.wind.deg;

        // Flecha base a 135º
        const rotation = (windDeg + 180 - 135 + 360) % 360;

        const arrow = document.getElementById("wind-arrow");
        arrow.style.transform = `rotate(${rotation}deg)`;
      } catch (error) {
        console.error("Error obteniendo el viento:", error);
      }
    }

    updateWindArrow();
  }

  function init() {
    if (!$(".home").length) return;
    initWind();
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Wind.init);
